// For manage routes of Pages
import { createRouter, createWebHistory } from "vue-router";
import CommisionReport from "@/views/CommisionReport.vue";
import OldCommisionReport from "@/views/OldCommisionReport.vue";
import MembershipReport from "@/views/MembershipReport.vue";
import CompanyStatisticsReport from "@/views/CompanyStatisticsReport.vue";
import NotFound from "@/views/Error/NotFound.vue";
import UnAuthorized from "@/views/Error/UnAuthorized.vue";
import Home from "@/views/Home.vue";
import Registration from "@/views/Auths/Registration.vue";
import Login from "@/views/Auths/Login.vue";
import ForgotPassword from "@/views/Auths/ForgotPassword.vue";
import VerifyOTP from "@/views/Auths/VerifyOTP.vue";
import ResetPassword from "@/views/Auths/ResetPassword.vue";
import AgentSelection from "@/views/Auths/AgentSelection.vue";
import Constants from "./constants.ts";
import { pushGtmPageView } from "./utils/gtm";

const routes = [
  {
    path: "/",
    redirect: "login",
  },
  {
    path: "/select-agent",
    name: "AgentSelection",
    component: AgentSelection,
    meta: {
      title: "AgentSelection",
    },
    beforeEnter: (to, from, next) => {
      let agentTkn = JSON.parse(localStorage.getItem("agent_data"));
      if (agentTkn != "" && agentTkn!=null && agentTkn!=undefined) {
        next();
      } else {
        next({ path: "/login" });
      }
    },
  },
  {
    path: "/register",
    name: "Registration",
    component: Registration,
    meta: {
      title: "Registration",
    },
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    component: ForgotPassword,
    meta: {
      title: "ForgotPassword",
    },
  },
  {
    path: "/verify-otp",
    name: "VerifyOTP",
    component: VerifyOTP,
    meta: {
      title: "VerifyOTP",
    },
  },
  {
    path: "/reset-password",
    name: "ResetPassword",
    component: ResetPassword,
    meta: {
      title: "ResetPassword",
    },
  },
  {
    path: "/login",
    name: "login",
    component: Login,
    meta: {
      title: "Login",
    },
    beforeEnter: (to, from, next) => {
      let logged_data = localStorage.getItem("agent_data");
      if (logged_data != null) {
        next({ path: "/home" });
      } else {
        next();
      }
    },
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: {
      title: "Home",
    },
    beforeEnter: (to, from, next) => {
      let agentTkn = JSON.parse(localStorage.getItem("agent_data"));
      let selected_agent = JSON.parse(localStorage.getItem("selected_agent"));
      if (agentTkn != "" && agentTkn!=null && agentTkn!=undefined) {
        if (
          selected_agent == null ||
          selected_agent == undefined ||
          selected_agent == ""
        ) {
          next({ path: "/select-agent" });
        } else {
          next();
        }
      } else {
        next({ path: "/login" });
      }
    },
  },
  {
    path: "/commission_report",
    name: "Commision Report",
    component: CommisionReport,
    meta: {
      title: "Commision Report",
    },
    beforeEnter: (to, from, next) => {
      let agentTkn = JSON.parse(localStorage.getItem("agent_data"));
      let selected_agent = JSON.parse(localStorage.getItem("selected_agent"));
      if (agentTkn != "" && agentTkn!=null && agentTkn!=undefined) {
        if (
          selected_agent == null ||
          selected_agent == undefined ||
          selected_agent == ""
        ) {
          next({ path: "/select-agent" });
        } else {
          next();
        }
      } else {
        next({ path: "/login" });
      }
    },
  },
  {
    path: "/old_commission_report",
    name: "Old Commision Report",
    component: OldCommisionReport,
    meta: {
      title: "Old Commision Report",
    },
    beforeEnter: (to, from, next) => {
      let agentTkn = JSON.parse(localStorage.getItem("agent_data"));
      let selected_agent = JSON.parse(localStorage.getItem("selected_agent"));
      if (agentTkn != "" && agentTkn!=null && agentTkn!=undefined) {
        if (
          selected_agent == null ||
          selected_agent == undefined ||
          selected_agent == ""
        ) {
          next({ path: "/select-agent" });
        } else {
          next();
        }
      } else {
        next({ path: "/login" });
      }
    },
  },
  {
    path: "/membership_report",
    name: "Membership Report",
    component: MembershipReport,
    meta: {
      title: "Membership Report",
    },
    beforeEnter: (to, from, next) => {
      let agentTkn = JSON.parse(localStorage.getItem("agent_data"));
      let selected_agent = JSON.parse(localStorage.getItem("selected_agent"));
      if (agentTkn != "" && agentTkn!=null && agentTkn!=undefined) {
        if (
          selected_agent == null ||
          selected_agent == undefined ||
          selected_agent == ""
        ) {
          next({ path: "/select-agent" });
        } else {
          next();
        }
      } else {
        next({ path: "/login" });
      }
    },
  },
  {
    path: "/company_statistics_report",
    name: "Company Statistics Report",
    component: CompanyStatisticsReport,
    meta: {
      title: "Company Statistics Report",
    },
    beforeEnter: (to, from, next) => {
      let agentTkn = JSON.parse(localStorage.getItem("agent_data"));
      let selected_agent = JSON.parse(localStorage.getItem("selected_agent"));
      if (agentTkn != "" && agentTkn!=null && agentTkn!=undefined) {
        if (
          selected_agent == null ||
          selected_agent == undefined ||
          selected_agent == ""
        ) {
          next({ path: "/select-agent" });
        } else {
          next();
        }
      } else {
        next({ path: "/login" });
      }
    },
  },
  {
    path: "/unauthorized",
    name: "UnAuthorized",
    component: UnAuthorized,
    meta: {
      title: "UnAuthorized",
    },
  },
  {
    path: "/:catchAll(.*)",
    component: NotFound,
    meta: {
      title: "404",
    },
  },
];
const router = createRouter({
  history: createWebHistory(),
  routes,
  mode: "history",
});

router.beforeEach((to, from, next) => {
  document.title = to.meta.title || Constants.documentTitle;
  next();
});
router.afterEach((to, from) => {
  localStorage.setItem("LS_ROUTE_KEY", from.name);
  pushGtmPageView(to);
});
export default router;
